import { QrCode, Swords } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

export default function CombineLaunchShortcut() {
  const location = useLocation()
  if (location.pathname !== '/coach') return null

  return (
    <div className="fixed right-4 bottom-5 z-[80] flex flex-col items-end gap-2 sm:right-6">
      <Link
        to="/coach/club-wars"
        className="border-hd-orange/35 bg-hd-dark/95 text-hd-orange hover:bg-hd-orange/10 inline-flex min-h-12 items-center gap-2 rounded-2xl border px-4 text-xs font-black shadow-2xl backdrop-blur-xl transition hover:-translate-y-0.5"
        aria-label="Open ARGUS Club Wars"
      >
        <Swords className="h-4 w-4" /> Club Wars
      </Link>
      <Link
        to="/coach/combine"
        className="border-hd-green/35 bg-hd-dark/95 text-hd-green hover:bg-hd-green/10 inline-flex min-h-12 items-center gap-2 rounded-2xl border px-4 text-xs font-black shadow-2xl backdrop-blur-xl transition hover:-translate-y-0.5"
        aria-label="Open ARGUS Combine"
      >
        <QrCode className="h-4 w-4" /> Combine
      </Link>
    </div>
  )
}
